require('./bootstrap');
feather.replace({'width': '20px','height':'20px','stroke-width':'2'});
